import React, { useRef, useEffect } from 'react';
import ibmLogo from '../assets/logo-ibm.jpg.asset.json';
import virtusLabLogo from '../assets/logo-virtuslab.jpg.asset.json';
import bexprtLogo from '../assets/logo-bexprt.jpg.asset.json';
import creatioLogo from '../assets/logo-creatio.png.asset.json';

const LogoScroller = () => {
  const scrollerRef = useRef<HTMLDivElement>(null);
  
  const logos = [
    { id: 7, name: "Thumba", imgUrl: "/lovable-uploads/thumba-logo.jpg" },
    { id: 3, name: "KPMG", imgUrl: "/lovable-uploads/727f7c47-c193-428c-9b21-5ebc5e076569.png" },
    { id: 6, name: "IBM", imgUrl: ibmLogo.url },
    { id: 8, name: "VirtusLab", imgUrl: virtusLabLogo.url },
    { id: 9, name: "Bexprt", imgUrl: bexprtLogo.url },
    { id: 10, name: "Creatio", imgUrl: creatioLogo.url },
  ];
  
  const allLogos = [...logos, ...logos];
  
  useEffect(() => {
    const animate = () => {
      if (!scrollerRef.current) return;
      
      scrollerRef.current.animate(
        [
          { transform: 'translateX(0)' },
          { transform: 'translateX(-50%)' }
        ],
        {
          duration: 4000, // Changed from 10000 to 4000 (much faster animation)
          iterations: Infinity,
          easing: 'linear'
        }
      );
    };
    
    animate();
  }, []);
  
  return (
    <div className="w-full py-8 bg-gray-100 overflow-hidden">
      <div className="relative flex overflow-x-hidden">
        <div 
          ref={scrollerRef}
          className="flex items-center whitespace-nowrap"
          style={{
            minWidth: '100%',
            willChange: 'transform'
          }}
        >
          {allLogos.map((logo, index) => (
            <div 
              key={`${logo.id}-${index}`}
              className="inline-block mx-[5px] flex items-center"
              style={{ minWidth: '170px' }} // Added fixed minimum width to maintain consistent size
            >
              <img 
                src={logo.imgUrl} 
                alt={`${logo.name} logo`}
                className="h-28 w-auto object-contain"
                style={{ 
                  opacity: 1, 
                  minWidth: '144px', 
                  filter: 'none' 
                }}
                loading="eager"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LogoScroller;
